export default "__VITE_ASSET__BPVRu85l__"